var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomePageImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 479,
    viewBox: "0 0 563 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.54 444.719C325.446 446.505 321.634 446.505 318.54 444.719L49.45 289.356L27.4586 302.057C25.459 303.212 25.4593 306.099 27.4591 307.253L318.54 475.309C321.634 477.095 325.446 477.095 328.54 475.309L546.613 349.404C553.279 345.556 553.28 335.934 546.614 332.085L535.12 325.446L328.54 444.719Z",
    fill: "url(#paint0_linear_1_1711)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.03 139.502C262.936 137.716 259.124 137.716 256.03 139.502L27.4599 271.468C25.4599 272.622 25.46 275.509 27.46 276.664L322.04 446.74C322.968 447.275 324.112 447.275 325.04 446.74L557.11 312.754C559.11 311.599 559.11 308.712 557.11 307.558L266.03 139.502Z",
    fill: "url(#paint1_linear_1_1711)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.03 139.501C262.936 137.715 259.124 137.716 256.031 139.502L27.4595 271.468C25.4596 272.622 25.4595 275.509 27.4593 276.664L71.2399 301.946L309.32 164.486L266.03 139.501Z",
    fill: "#083B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M561.61 310.156L328.54 444.719C325.446 446.505 321.634 446.505 318.54 444.719L22.96 274.066",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.07 252.696C240.457 252.696 240.77 252.382 240.77 251.996C240.77 251.609 240.457 251.296 240.07 251.296C239.683 251.296 239.37 251.609 239.37 251.996C239.37 252.382 239.683 252.696 240.07 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 257.336C248.497 257.336 248.81 257.022 248.81 256.636C248.81 256.249 248.497 255.936 248.11 255.936C247.723 255.936 247.41 256.249 247.41 256.636C247.41 257.022 247.723 257.336 248.11 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 261.976C240.457 261.976 240.77 261.662 240.77 261.276C240.77 260.889 240.457 260.576 240.07 260.576C239.683 260.576 239.37 260.889 239.37 261.276C239.37 261.662 239.683 261.976 240.07 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 261.976C256.537 261.976 256.85 261.662 256.85 261.276C256.85 260.889 256.537 260.576 256.15 260.576C255.763 260.576 255.45 260.889 255.45 261.276C255.45 261.662 255.763 261.976 256.15 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 266.626C248.497 266.626 248.81 266.312 248.81 265.926C248.81 265.539 248.497 265.226 248.11 265.226C247.723 265.226 247.41 265.539 247.41 265.926C247.41 266.312 247.723 266.626 248.11 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 271.266C240.457 271.266 240.77 270.952 240.77 270.566C240.77 270.179 240.457 269.866 240.07 269.866C239.683 269.866 239.37 270.179 239.37 270.566C239.37 270.952 239.683 271.266 240.07 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 266.626C264.577 266.626 264.89 266.312 264.89 265.926C264.89 265.539 264.577 265.226 264.19 265.226C263.803 265.226 263.49 265.539 263.49 265.926C263.49 266.312 263.803 266.626 264.19 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 271.266C256.537 271.266 256.85 270.952 256.85 270.566C256.85 270.179 256.537 269.866 256.15 269.866C255.763 269.866 255.45 270.179 255.45 270.566C255.45 270.952 255.763 271.266 256.15 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 275.906C248.497 275.906 248.81 275.592 248.81 275.206C248.81 274.819 248.497 274.506 248.11 274.506C247.723 274.506 247.41 274.819 247.41 275.206C247.41 275.592 247.723 275.906 248.11 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 280.546C240.457 280.546 240.77 280.232 240.77 279.846C240.77 279.459 240.457 279.146 240.07 279.146C239.683 279.146 239.37 279.459 239.37 279.846C239.37 280.232 239.683 280.546 240.07 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 275.906C264.577 275.906 264.89 275.592 264.89 275.206C264.89 274.819 264.577 274.506 264.19 274.506C263.803 274.506 263.49 274.819 263.49 275.206C263.49 275.592 263.803 275.906 264.19 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 280.546C256.537 280.546 256.85 280.232 256.85 279.846C256.85 279.459 256.537 279.146 256.15 279.146C255.763 279.146 255.45 279.459 255.45 279.846C255.45 280.232 255.763 280.546 256.15 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 271.266C272.617 271.266 272.93 270.952 272.93 270.566C272.93 270.179 272.617 269.866 272.23 269.866C271.843 269.866 271.53 270.179 271.53 270.566C271.53 270.952 271.843 271.266 272.23 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 285.196C248.497 285.196 248.81 284.882 248.81 284.496C248.81 284.109 248.497 283.796 248.11 283.796C247.723 283.796 247.41 284.109 247.41 284.496C247.41 284.882 247.723 285.196 248.11 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 289.836C240.457 289.836 240.77 289.522 240.77 289.136C240.77 288.749 240.457 288.436 240.07 288.436C239.683 288.436 239.37 288.749 239.37 289.136C239.37 289.522 239.683 289.836 240.07 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 257.336C232.417 257.336 232.73 257.022 232.73 256.636C232.73 256.249 232.417 255.936 232.03 255.936C231.643 255.936 231.33 256.249 231.33 256.636C231.33 257.022 231.643 257.336 232.03 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 243.406C256.537 243.406 256.85 243.092 256.85 242.706C256.85 242.319 256.537 242.006 256.15 242.006C255.763 242.006 255.45 242.319 255.45 242.706C255.45 243.092 255.763 243.406 256.15 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 248.056C264.577 248.056 264.89 247.742 264.89 247.356C264.89 246.969 264.577 246.656 264.19 246.656C263.803 246.656 263.49 246.969 263.49 247.356C263.49 247.742 263.803 248.056 264.19 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 252.696C256.537 252.696 256.85 252.382 256.85 251.996C256.85 251.609 256.537 251.296 256.15 251.296C255.763 251.296 255.45 251.609 255.45 251.996C255.45 252.382 255.763 252.696 256.15 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 252.696C272.617 252.696 272.93 252.382 272.93 251.996C272.93 251.609 272.617 251.296 272.23 251.296C271.843 251.296 271.53 251.609 271.53 251.996C271.53 252.382 271.843 252.696 272.23 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 257.336C264.577 257.336 264.89 257.022 264.89 256.636C264.89 256.249 264.577 255.936 264.19 255.936C263.803 255.936 263.49 256.249 263.49 256.636C263.49 257.022 263.803 257.336 264.19 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 257.336C280.667 257.336 280.98 257.022 280.98 256.636C280.98 256.249 280.667 255.936 280.28 255.936C279.893 255.936 279.58 256.249 279.58 256.636C279.58 257.022 279.893 257.336 280.28 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 261.976C272.617 261.976 272.93 261.662 272.93 261.276C272.93 260.889 272.617 260.576 272.23 260.576C271.843 260.576 271.53 260.889 271.53 261.276C271.53 261.662 271.843 261.976 272.23 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 266.626C280.667 266.626 280.98 266.312 280.98 265.926C280.98 265.539 280.667 265.226 280.28 265.226C279.893 265.226 279.58 265.539 279.58 265.926C279.58 266.312 279.893 266.626 280.28 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 261.976C288.707 261.976 289.02 261.662 289.02 261.276C289.02 260.889 288.707 260.576 288.32 260.576C287.933 260.576 287.62 260.889 287.62 261.276C287.62 261.662 287.933 261.976 288.32 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 248.056C248.497 248.056 248.81 247.742 248.81 247.356C248.81 246.969 248.497 246.656 248.11 246.656C247.723 246.656 247.41 246.969 247.41 247.356C247.41 247.742 247.723 248.056 248.11 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 243.406C272.617 243.406 272.93 243.092 272.93 242.706C272.93 242.319 272.617 242.006 272.23 242.006C271.843 242.006 271.53 242.319 271.53 242.706C271.53 243.092 271.843 243.406 272.23 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 248.056C280.667 248.056 280.98 247.742 280.98 247.356C280.98 246.969 280.667 246.656 280.28 246.656C279.893 246.656 279.58 246.969 279.58 247.356C279.58 247.742 279.893 248.056 280.28 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 252.696C288.707 252.696 289.02 252.382 289.02 251.996C289.02 251.609 288.707 251.296 288.32 251.296C287.933 251.296 287.62 251.609 287.62 251.996C287.62 252.382 287.933 252.696 288.32 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 257.336C296.747 257.336 297.06 257.022 297.06 256.636C297.06 256.249 296.747 255.936 296.36 255.936C295.973 255.936 295.66 256.249 295.66 256.636C295.66 257.022 295.973 257.336 296.36 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 280.546C272.617 280.546 272.93 280.232 272.93 279.846C272.93 279.459 272.617 279.146 272.23 279.146C271.843 279.146 271.53 279.459 271.53 279.846C271.53 280.232 271.843 280.546 272.23 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 285.196C264.577 285.196 264.89 284.882 264.89 284.496C264.89 284.109 264.577 283.796 264.19 283.796C263.803 283.796 263.49 284.109 263.49 284.496C263.49 284.882 263.803 285.196 264.19 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 275.906C280.667 275.906 280.98 275.592 280.98 275.206C280.98 274.819 280.667 274.506 280.28 274.506C279.893 274.506 279.58 274.819 279.58 275.206C279.58 275.592 279.893 275.906 280.28 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 289.836C256.537 289.836 256.85 289.522 256.85 289.136C256.85 288.749 256.537 288.436 256.15 288.436C255.763 288.436 255.45 288.749 255.45 289.136C255.45 289.522 255.763 289.836 256.15 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 294.476C248.497 294.476 248.81 294.162 248.81 293.776C248.81 293.389 248.497 293.076 248.11 293.076C247.723 293.076 247.41 293.389 247.41 293.776C247.41 294.162 247.723 294.476 248.11 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 271.266C288.707 271.266 289.02 270.952 289.02 270.566C289.02 270.179 288.707 269.866 288.32 269.866C287.933 269.866 287.62 270.179 287.62 270.566C287.62 270.952 287.933 271.266 288.32 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 266.626C296.747 266.626 297.06 266.312 297.06 265.926C297.06 265.539 296.747 265.226 296.36 265.226C295.973 265.226 295.66 265.539 295.66 265.926C295.66 266.312 295.973 266.626 296.36 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 261.976C304.787 261.976 305.1 261.662 305.1 261.276C305.1 260.889 304.787 260.576 304.4 260.576C304.013 260.576 303.7 260.889 303.7 261.276C303.7 261.662 304.013 261.976 304.4 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 285.196C280.667 285.196 280.98 284.882 280.98 284.496C280.98 284.109 280.667 283.796 280.28 283.796C279.893 283.796 279.58 284.109 279.58 284.496C279.58 284.882 279.893 285.196 280.28 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 289.836C272.617 289.836 272.93 289.522 272.93 289.136C272.93 288.749 272.617 288.436 272.23 288.436C271.843 288.436 271.53 288.749 271.53 289.136C271.53 289.522 271.843 289.836 272.23 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 280.546C288.707 280.546 289.02 280.232 289.02 279.846C289.02 279.459 288.707 279.146 288.32 279.146C287.933 279.146 287.62 279.459 287.62 279.846C287.62 280.232 287.933 280.546 288.32 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 294.476C264.577 294.476 264.89 294.162 264.89 293.776C264.89 293.389 264.577 293.076 264.19 293.076C263.803 293.076 263.49 293.389 263.49 293.776C263.49 294.162 263.803 294.476 264.19 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 299.126C256.537 299.126 256.85 298.812 256.85 298.426C256.85 298.039 256.537 297.726 256.15 297.726C255.763 297.726 255.45 298.039 255.45 298.426C255.45 298.812 255.763 299.126 256.15 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 275.906C296.747 275.906 297.06 275.592 297.06 275.206C297.06 274.819 296.747 274.506 296.36 274.506C295.973 274.506 295.66 274.819 295.66 275.206C295.66 275.592 295.973 275.906 296.36 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 271.266C304.787 271.266 305.1 270.952 305.1 270.566C305.1 270.179 304.787 269.866 304.4 269.866C304.013 269.866 303.7 270.179 303.7 270.566C303.7 270.952 304.013 271.266 304.4 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 266.626C312.827 266.626 313.14 266.312 313.14 265.926C313.14 265.539 312.827 265.226 312.44 265.226C312.053 265.226 311.74 265.539 311.74 265.926C311.74 266.312 312.053 266.626 312.44 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 289.836C288.707 289.836 289.02 289.522 289.02 289.136C289.02 288.749 288.707 288.436 288.32 288.436C287.933 288.436 287.62 288.749 287.62 289.136C287.62 289.522 287.933 289.836 288.32 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 294.476C280.667 294.476 280.98 294.162 280.98 293.776C280.98 293.389 280.667 293.076 280.28 293.076C279.893 293.076 279.58 293.389 279.58 293.776C279.58 294.162 279.893 294.476 280.28 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 285.196C296.747 285.196 297.06 284.882 297.06 284.496C297.06 284.109 296.747 283.796 296.36 283.796C295.973 283.796 295.66 284.109 295.66 284.496C295.66 284.882 295.973 285.196 296.36 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 299.126C272.617 299.126 272.93 298.812 272.93 298.426C272.93 298.039 272.617 297.726 272.23 297.726C271.843 297.726 271.53 298.039 271.53 298.426C271.53 298.812 271.843 299.126 272.23 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 303.766C264.577 303.766 264.89 303.452 264.89 303.066C264.89 302.679 264.577 302.366 264.19 302.366C263.803 302.366 263.49 302.679 263.49 303.066C263.49 303.452 263.803 303.766 264.19 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 280.546C304.787 280.546 305.1 280.232 305.1 279.846C305.1 279.459 304.787 279.146 304.4 279.146C304.013 279.146 303.7 279.459 303.7 279.846C303.7 280.232 304.013 280.546 304.4 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 275.906C312.827 275.906 313.14 275.592 313.14 275.206C313.14 274.819 312.827 274.506 312.44 274.506C312.053 274.506 311.74 274.819 311.74 275.206C311.74 275.592 312.053 275.906 312.44 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 271.266C320.867 271.266 321.18 270.952 321.18 270.566C321.18 270.179 320.867 269.866 320.48 269.866C320.093 269.866 319.78 270.179 319.78 270.566C319.78 270.952 320.093 271.266 320.48 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 294.476C296.747 294.476 297.06 294.162 297.06 293.776C297.06 293.389 296.747 293.076 296.36 293.076C295.973 293.076 295.66 293.389 295.66 293.776C295.66 294.162 295.973 294.476 296.36 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 299.126C288.707 299.126 289.02 298.812 289.02 298.426C289.02 298.039 288.707 297.726 288.32 297.726C287.933 297.726 287.62 298.039 287.62 298.426C287.62 298.812 287.933 299.126 288.32 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 289.836C304.787 289.836 305.1 289.522 305.1 289.136C305.1 288.749 304.787 288.436 304.4 288.436C304.013 288.436 303.7 288.749 303.7 289.136C303.7 289.522 304.013 289.836 304.4 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 303.766C280.667 303.766 280.98 303.452 280.98 303.066C280.98 302.679 280.667 302.366 280.28 302.366C279.893 302.366 279.58 302.679 279.58 303.066C279.58 303.452 279.893 303.766 280.28 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 308.406C272.617 308.406 272.93 308.092 272.93 307.706C272.93 307.319 272.617 307.006 272.23 307.006C271.843 307.006 271.53 307.319 271.53 307.706C271.53 308.092 271.843 308.406 272.23 308.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 285.196C312.827 285.196 313.14 284.882 313.14 284.496C313.14 284.109 312.827 283.796 312.44 283.796C312.053 283.796 311.74 284.109 311.74 284.496C311.74 284.882 312.053 285.196 312.44 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 280.546C320.867 280.546 321.18 280.232 321.18 279.846C321.18 279.459 320.867 279.146 320.48 279.146C320.093 279.146 319.78 279.459 319.78 279.846C319.78 280.232 320.093 280.546 320.48 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 275.906C328.907 275.906 329.22 275.592 329.22 275.206C329.22 274.819 328.907 274.506 328.52 274.506C328.133 274.506 327.82 274.819 327.82 275.206C327.82 275.592 328.133 275.906 328.52 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 299.126C304.787 299.126 305.1 298.812 305.1 298.426C305.1 298.039 304.787 297.726 304.4 297.726C304.013 297.726 303.7 298.039 303.7 298.426C303.7 298.812 304.013 299.126 304.4 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 303.766C296.747 303.766 297.06 303.452 297.06 303.066C297.06 302.679 296.747 302.366 296.36 302.366C295.973 302.366 295.66 302.679 295.66 303.066C295.66 303.452 295.973 303.766 296.36 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 294.476C312.827 294.476 313.14 294.162 313.14 293.776C313.14 293.389 312.827 293.076 312.44 293.076C312.053 293.076 311.74 293.389 311.74 293.776C311.74 294.162 312.053 294.476 312.44 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 308.406C288.707 308.406 289.02 308.092 289.02 307.706C289.02 307.319 288.707 307.006 288.32 307.006C287.933 307.006 287.62 307.319 287.62 307.706C287.62 308.092 287.933 308.406 288.32 308.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 313.046C280.667 313.046 280.98 312.732 280.98 312.346C280.98 311.959 280.667 311.646 280.28 311.646C279.893 311.646 279.58 311.959 279.58 312.346C279.58 312.732 279.893 313.046 280.28 313.046Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 289.836C320.867 289.836 321.18 289.522 321.18 289.136C321.18 288.749 320.867 288.436 320.48 288.436C320.093 288.436 319.78 288.749 319.78 289.136C319.78 289.522 320.093 289.836 320.48 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 285.196C328.907 285.196 329.22 284.882 329.22 284.496C329.22 284.109 328.907 283.796 328.52 283.796C328.133 283.796 327.82 284.109 327.82 284.496C327.82 284.882 328.133 285.196 328.52 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 280.546C336.957 280.546 337.27 280.232 337.27 279.846C337.27 279.459 336.957 279.146 336.57 279.146C336.183 279.146 335.87 279.459 335.87 279.846C335.87 280.232 336.183 280.546 336.57 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 303.766C312.827 303.766 313.14 303.452 313.14 303.066C313.14 302.679 312.827 302.366 312.44 302.366C312.053 302.366 311.74 302.679 311.74 303.066C311.74 303.452 312.053 303.766 312.44 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 308.406C304.787 308.406 305.1 308.092 305.1 307.706C305.1 307.319 304.787 307.006 304.4 307.006C304.013 307.006 303.7 307.319 303.7 307.706C303.7 308.092 304.013 308.406 304.4 308.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 299.126C320.867 299.126 321.18 298.812 321.18 298.426C321.18 298.039 320.867 297.726 320.48 297.726C320.093 297.726 319.78 298.039 319.78 298.426C319.78 298.812 320.093 299.126 320.48 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 313.046C296.747 313.046 297.06 312.732 297.06 312.346C297.06 311.959 296.747 311.646 296.36 311.646C295.973 311.646 295.66 311.959 295.66 312.346C295.66 312.732 295.973 313.046 296.36 313.046Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 317.696C288.707 317.696 289.02 317.382 289.02 316.996C289.02 316.609 288.707 316.296 288.32 316.296C287.933 316.296 287.62 316.609 287.62 316.996C287.62 317.382 287.933 317.696 288.32 317.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 294.476C328.907 294.476 329.22 294.162 329.22 293.776C329.22 293.389 328.907 293.076 328.52 293.076C328.133 293.076 327.82 293.389 327.82 293.776C327.82 294.162 328.133 294.476 328.52 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 289.836C336.957 289.836 337.27 289.522 337.27 289.136C337.27 288.749 336.957 288.436 336.57 288.436C336.183 288.436 335.87 288.749 335.87 289.136C335.87 289.522 336.183 289.836 336.57 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 285.196C344.997 285.196 345.31 284.882 345.31 284.496C345.31 284.109 344.997 283.796 344.61 283.796C344.223 283.796 343.91 284.109 343.91 284.496C343.91 284.882 344.223 285.196 344.61 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 308.406C320.867 308.406 321.18 308.092 321.18 307.706C321.18 307.319 320.867 307.006 320.48 307.006C320.093 307.006 319.78 307.319 319.78 307.706C319.78 308.092 320.093 308.406 320.48 308.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 313.046C312.827 313.046 313.14 312.732 313.14 312.346C313.14 311.959 312.827 311.646 312.44 311.646C312.053 311.646 311.74 311.959 311.74 312.346C311.74 312.732 312.053 313.046 312.44 313.046Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 303.766C328.907 303.766 329.22 303.452 329.22 303.066C329.22 302.679 328.907 302.366 328.52 302.366C328.133 302.366 327.82 302.679 327.82 303.066C327.82 303.452 328.133 303.766 328.52 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 317.696C304.787 317.696 305.1 317.382 305.1 316.996C305.1 316.609 304.787 316.296 304.4 316.296C304.013 316.296 303.7 316.609 303.7 316.996C303.7 317.382 304.013 317.696 304.4 317.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 322.336C296.747 322.336 297.06 322.022 297.06 321.636C297.06 321.249 296.747 320.936 296.36 320.936C295.973 320.936 295.66 321.249 295.66 321.636C295.66 322.022 295.973 322.336 296.36 322.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 299.126C336.957 299.126 337.27 298.812 337.27 298.426C337.27 298.039 336.957 297.726 336.57 297.726C336.183 297.726 335.87 298.039 335.87 298.426C335.87 298.812 336.183 299.126 336.57 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 294.476C344.997 294.476 345.31 294.162 345.31 293.776C345.31 293.389 344.997 293.076 344.61 293.076C344.223 293.076 343.91 293.389 343.91 293.776C343.91 294.162 344.223 294.476 344.61 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 289.836C353.037 289.836 353.35 289.522 353.35 289.136C353.35 288.749 353.037 288.436 352.65 288.436C352.263 288.436 351.95 288.749 351.95 289.136C351.95 289.522 352.263 289.836 352.65 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 313.046C328.907 313.046 329.22 312.732 329.22 312.346C329.22 311.959 328.907 311.646 328.52 311.646C328.133 311.646 327.82 311.959 327.82 312.346C327.82 312.732 328.133 313.046 328.52 313.046Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 317.696C320.867 317.696 321.18 317.382 321.18 316.996C321.18 316.609 320.867 316.296 320.48 316.296C320.093 316.296 319.78 316.609 319.78 316.996C319.78 317.382 320.093 317.696 320.48 317.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 308.406C336.957 308.406 337.27 308.092 337.27 307.706C337.27 307.319 336.957 307.006 336.57 307.006C336.183 307.006 335.87 307.319 335.87 307.706C335.87 308.092 336.183 308.406 336.57 308.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 322.336C312.827 322.336 313.14 322.022 313.14 321.636C313.14 321.249 312.827 320.936 312.44 320.936C312.053 320.936 311.74 321.249 311.74 321.636C311.74 322.022 312.053 322.336 312.44 322.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 326.976C304.787 326.976 305.1 326.662 305.1 326.276C305.1 325.889 304.787 325.576 304.4 325.576C304.013 325.576 303.7 325.889 303.7 326.276C303.7 326.662 304.013 326.976 304.4 326.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 303.766C344.997 303.766 345.31 303.452 345.31 303.066C345.31 302.679 344.997 302.366 344.61 302.366C344.223 302.366 343.91 302.679 343.91 303.066C343.91 303.452 344.223 303.766 344.61 303.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 299.126C353.037 299.126 353.35 298.812 353.35 298.426C353.35 298.039 353.037 297.726 352.65 297.726C352.263 297.726 351.95 298.039 351.95 298.426C351.95 298.812 352.263 299.126 352.65 299.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 294.476C361.077 294.476 361.39 294.162 361.39 293.776C361.39 293.389 361.077 293.076 360.69 293.076C360.303 293.076 359.99 293.389 359.99 293.776C359.99 294.162 360.303 294.476 360.69 294.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 289.836C369.117 289.836 369.43 289.522 369.43 289.136C369.43 288.749 369.117 288.436 368.73 288.436C368.343 288.436 368.03 288.749 368.03 289.136C368.03 289.522 368.343 289.836 368.73 289.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 238.766C264.577 238.766 264.89 238.452 264.89 238.066C264.89 237.679 264.577 237.366 264.19 237.366C263.803 237.366 263.49 237.679 263.49 238.066C263.49 238.452 263.803 238.766 264.19 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 261.976C224.377 261.976 224.69 261.662 224.69 261.276C224.69 260.889 224.377 260.576 223.99 260.576C223.603 260.576 223.29 260.889 223.29 261.276C223.29 261.662 223.603 261.976 223.99 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 266.626C232.417 266.626 232.73 266.312 232.73 265.926C232.73 265.539 232.417 265.226 232.03 265.226C231.643 265.226 231.33 265.539 231.33 265.926C231.33 266.312 231.643 266.626 232.03 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.95 266.626C216.337 266.626 216.65 266.312 216.65 265.926C216.65 265.539 216.337 265.226 215.95 265.226C215.563 265.226 215.25 265.539 215.25 265.926C215.25 266.312 215.563 266.626 215.95 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 271.266C224.377 271.266 224.69 270.952 224.69 270.566C224.69 270.179 224.377 269.866 223.99 269.866C223.603 269.866 223.29 270.179 223.29 270.566C223.29 270.952 223.603 271.266 223.99 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 275.906C232.417 275.906 232.73 275.592 232.73 275.206C232.73 274.819 232.417 274.506 232.03 274.506C231.643 274.506 231.33 274.819 231.33 275.206C231.33 275.592 231.643 275.906 232.03 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.95 275.906C216.337 275.906 216.65 275.592 216.65 275.206C216.65 274.819 216.337 274.506 215.95 274.506C215.563 274.506 215.25 274.819 215.25 275.206C215.25 275.592 215.563 275.906 215.95 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 280.546C224.377 280.546 224.69 280.232 224.69 279.846C224.69 279.459 224.377 279.146 223.99 279.146C223.603 279.146 223.29 279.459 223.29 279.846C223.29 280.232 223.603 280.546 223.99 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 271.266C208.287 271.266 208.6 270.952 208.6 270.566C208.6 270.179 208.287 269.866 207.9 269.866C207.513 269.866 207.2 270.179 207.2 270.566C207.2 270.952 207.513 271.266 207.9 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 285.196C232.417 285.196 232.73 284.882 232.73 284.496C232.73 284.109 232.417 283.796 232.03 283.796C231.643 283.796 231.33 284.109 231.33 284.496C231.33 284.882 231.643 285.196 232.03 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.95 257.336C216.337 257.336 216.65 257.022 216.65 256.636C216.65 256.249 216.337 255.936 215.95 255.936C215.563 255.936 215.25 256.249 215.25 256.636C215.25 257.022 215.563 257.336 215.95 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 261.976C208.287 261.976 208.6 261.662 208.6 261.276C208.6 260.889 208.287 260.576 207.9 260.576C207.513 260.576 207.2 260.889 207.2 261.276C207.2 261.662 207.513 261.976 207.9 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 248.056C232.417 248.056 232.73 247.742 232.73 247.356C232.73 246.969 232.417 246.656 232.03 246.656C231.643 246.656 231.33 246.969 231.33 247.356C231.33 247.742 231.643 248.056 232.03 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 252.696C224.377 252.696 224.69 252.382 224.69 251.996C224.69 251.609 224.377 251.296 223.99 251.296C223.603 251.296 223.29 251.609 223.29 251.996C223.29 252.382 223.603 252.696 223.99 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 243.406C240.457 243.406 240.77 243.092 240.77 242.706C240.77 242.319 240.457 242.006 240.07 242.006C239.683 242.006 239.37 242.319 239.37 242.706C239.37 243.092 239.683 243.406 240.07 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.86 266.626C200.247 266.626 200.56 266.312 200.56 265.926C200.56 265.539 200.247 265.226 199.86 265.226C199.473 265.226 199.16 265.539 199.16 265.926C199.16 266.312 199.473 266.626 199.86 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.95 238.766C216.337 238.766 216.65 238.452 216.65 238.066C216.65 237.679 216.337 237.366 215.95 237.366C215.563 237.366 215.25 237.679 215.25 238.066C215.25 238.452 215.563 238.766 215.95 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 243.406C208.287 243.406 208.6 243.092 208.6 242.706C208.6 242.319 208.287 242.006 207.9 242.006C207.513 242.006 207.2 242.319 207.2 242.706C207.2 243.092 207.513 243.406 207.9 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.86 248.056C200.247 248.056 200.56 247.742 200.56 247.356C200.56 246.969 200.247 246.656 199.86 246.656C199.473 246.656 199.16 246.969 199.16 247.356C199.16 247.742 199.473 248.056 199.86 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82 252.696C192.207 252.696 192.52 252.382 192.52 251.996C192.52 251.609 192.207 251.296 191.82 251.296C191.433 251.296 191.12 251.609 191.12 251.996C191.12 252.382 191.433 252.696 191.82 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.95 248.056C216.337 248.056 216.65 247.742 216.65 247.356C216.65 246.969 216.337 246.656 215.95 246.656C215.563 246.656 215.25 246.969 215.25 247.356C215.25 247.742 215.563 248.056 215.95 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 252.696C208.287 252.696 208.6 252.382 208.6 251.996C208.6 251.609 208.287 251.296 207.9 251.296C207.513 251.296 207.2 251.609 207.2 251.996C207.2 252.382 207.513 252.696 207.9 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 243.406C224.377 243.406 224.69 243.092 224.69 242.706C224.69 242.319 224.377 242.006 223.99 242.006C223.603 242.006 223.29 242.319 223.29 242.706C223.29 243.092 223.603 243.406 223.99 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.86 257.336C200.247 257.336 200.56 257.022 200.56 256.636C200.56 256.249 200.247 255.936 199.86 255.936C199.473 255.936 199.16 256.249 199.16 256.636C199.16 257.022 199.473 257.336 199.86 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82 261.976C192.207 261.976 192.52 261.662 192.52 261.276C192.52 260.889 192.207 260.576 191.82 260.576C191.433 260.576 191.12 260.889 191.12 261.276C191.12 261.662 191.433 261.976 191.82 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 238.766C248.497 238.766 248.81 238.452 248.81 238.066C248.81 237.679 248.497 237.366 248.11 237.366C247.723 237.366 247.41 237.679 247.41 238.066C247.41 238.452 247.723 238.766 248.11 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 229.476C232.417 229.476 232.73 229.162 232.73 228.776C232.73 228.389 232.417 228.076 232.03 228.076C231.643 228.076 231.33 228.389 231.33 228.776C231.33 229.162 231.643 229.476 232.03 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 234.126C224.377 234.126 224.69 233.812 224.69 233.426C224.69 233.039 224.377 232.726 223.99 232.726C223.603 232.726 223.29 233.039 223.29 233.426C223.29 233.812 223.603 234.126 223.99 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.03 238.766C232.417 238.766 232.73 238.452 232.73 238.066C232.73 237.679 232.417 237.366 232.03 237.366C231.643 237.366 231.33 237.679 231.33 238.066C231.33 238.452 231.643 238.766 232.03 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 234.126C240.457 234.126 240.77 233.812 240.77 233.426C240.77 233.039 240.457 232.726 240.07 232.726C239.683 232.726 239.37 233.039 239.37 233.426C239.37 233.812 239.683 234.126 240.07 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 234.126C256.537 234.126 256.85 233.812 256.85 233.426C256.85 233.039 256.537 232.726 256.15 232.726C255.763 232.726 255.45 233.039 255.45 233.426C255.45 233.812 255.763 234.126 256.15 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07 224.836C240.457 224.836 240.77 224.522 240.77 224.136C240.77 223.749 240.457 223.436 240.07 223.436C239.683 223.436 239.37 223.749 239.37 224.136C239.37 224.522 239.683 224.836 240.07 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 229.476C248.497 229.476 248.81 229.162 248.81 228.776C248.81 228.389 248.497 228.076 248.11 228.076C247.723 228.076 247.41 228.389 247.41 228.776C247.41 229.162 247.723 229.476 248.11 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78 257.336C184.167 257.336 184.48 257.022 184.48 256.636C184.48 256.249 184.167 255.936 183.78 255.936C183.393 255.936 183.08 256.249 183.08 256.636C183.08 257.022 183.393 257.336 183.78 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 215.556C304.787 215.556 305.1 215.242 305.1 214.856C305.1 214.469 304.787 214.156 304.4 214.156C304.013 214.156 303.7 214.469 303.7 214.856C303.7 215.242 304.013 215.556 304.4 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 220.196C312.827 220.196 313.14 219.882 313.14 219.496C313.14 219.109 312.827 218.796 312.44 218.796C312.053 218.796 311.74 219.109 311.74 219.496C311.74 219.882 312.053 220.196 312.44 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 224.836C304.787 224.836 305.1 224.522 305.1 224.136C305.1 223.749 304.787 223.436 304.4 223.436C304.013 223.436 303.7 223.749 303.7 224.136C303.7 224.522 304.013 224.836 304.4 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 224.836C320.867 224.836 321.18 224.522 321.18 224.136C321.18 223.749 320.867 223.436 320.48 223.436C320.093 223.436 319.78 223.749 319.78 224.136C319.78 224.522 320.093 224.836 320.48 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 229.476C312.827 229.476 313.14 229.162 313.14 228.776C313.14 228.389 312.827 228.076 312.44 228.076C312.053 228.076 311.74 228.389 311.74 228.776C311.74 229.162 312.053 229.476 312.44 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 234.126C304.787 234.126 305.1 233.812 305.1 233.426C305.1 233.039 304.787 232.726 304.4 232.726C304.013 232.726 303.7 233.039 303.7 233.426C303.7 233.812 304.013 234.126 304.4 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 229.476C328.907 229.476 329.22 229.162 329.22 228.776C329.22 228.389 328.907 228.076 328.52 228.076C328.133 228.076 327.82 228.389 327.82 228.776C327.82 229.162 328.133 229.476 328.52 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 234.126C320.867 234.126 321.18 233.812 321.18 233.426C321.18 233.039 320.867 232.726 320.48 232.726C320.093 232.726 319.78 233.039 319.78 233.426C319.78 233.812 320.093 234.126 320.48 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 238.766C312.827 238.766 313.14 238.452 313.14 238.066C313.14 237.679 312.827 237.366 312.44 237.366C312.053 237.366 311.74 237.679 311.74 238.066C311.74 238.452 312.053 238.766 312.44 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 243.406C304.787 243.406 305.1 243.092 305.1 242.706C305.1 242.319 304.787 242.006 304.4 242.006C304.013 242.006 303.7 242.319 303.7 242.706C303.7 243.092 304.013 243.406 304.4 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 238.766C328.907 238.766 329.22 238.452 329.22 238.066C329.22 237.679 328.907 237.366 328.52 237.366C328.133 237.366 327.82 237.679 327.82 238.066C327.82 238.452 328.133 238.766 328.52 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 243.406C320.867 243.406 321.18 243.092 321.18 242.706C321.18 242.319 320.867 242.006 320.48 242.006C320.093 242.006 319.78 242.319 319.78 242.706C319.78 243.092 320.093 243.406 320.48 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 234.126C336.957 234.126 337.27 233.812 337.27 233.426C337.27 233.039 336.957 232.726 336.57 232.726C336.183 232.726 335.87 233.039 335.87 233.426C335.87 233.812 336.183 234.126 336.57 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 248.056C312.827 248.056 313.14 247.742 313.14 247.356C313.14 246.969 312.827 246.656 312.44 246.656C312.053 246.656 311.74 246.969 311.74 247.356C311.74 247.742 312.053 248.056 312.44 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 252.696C304.787 252.696 305.1 252.382 305.1 251.996C305.1 251.609 304.787 251.296 304.4 251.296C304.013 251.296 303.7 251.609 303.7 251.996C303.7 252.382 304.013 252.696 304.4 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 220.196C296.747 220.196 297.06 219.882 297.06 219.496C297.06 219.109 296.747 218.796 296.36 218.796C295.973 218.796 295.66 219.109 295.66 219.496C295.66 219.882 295.973 220.196 296.36 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 206.266C320.867 206.266 321.18 205.952 321.18 205.566C321.18 205.179 320.867 204.866 320.48 204.866C320.093 204.866 319.78 205.179 319.78 205.566C319.78 205.952 320.093 206.266 320.48 206.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 210.906C328.907 210.906 329.22 210.592 329.22 210.206C329.22 209.819 328.907 209.506 328.52 209.506C328.133 209.506 327.82 209.819 327.82 210.206C327.82 210.592 328.133 210.906 328.52 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 215.556C320.867 215.556 321.18 215.242 321.18 214.856C321.18 214.469 320.867 214.156 320.48 214.156C320.093 214.156 319.78 214.469 319.78 214.856C319.78 215.242 320.093 215.556 320.48 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 215.556C336.957 215.556 337.27 215.242 337.27 214.856C337.27 214.469 336.957 214.156 336.57 214.156C336.183 214.156 335.87 214.469 335.87 214.856C335.87 215.242 336.183 215.556 336.57 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 220.196C328.907 220.196 329.22 219.882 329.22 219.496C329.22 219.109 328.907 218.796 328.52 218.796C328.133 218.796 327.82 219.109 327.82 219.496C327.82 219.882 328.133 220.196 328.52 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 220.196C344.997 220.196 345.31 219.882 345.31 219.496C345.31 219.109 344.997 218.796 344.61 218.796C344.223 218.796 343.91 219.109 343.91 219.496C343.91 219.882 344.223 220.196 344.61 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 224.836C336.957 224.836 337.27 224.522 337.27 224.136C337.27 223.749 336.957 223.436 336.57 223.436C336.183 223.436 335.87 223.749 335.87 224.136C335.87 224.522 336.183 224.836 336.57 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 229.476C344.997 229.476 345.31 229.162 345.31 228.776C345.31 228.389 344.997 228.076 344.61 228.076C344.223 228.076 343.91 228.389 343.91 228.776C343.91 229.162 344.223 229.476 344.61 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 224.836C353.037 224.836 353.35 224.522 353.35 224.136C353.35 223.749 353.037 223.436 352.65 223.436C352.263 223.436 351.95 223.749 351.95 224.136C351.95 224.522 352.263 224.836 352.65 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 210.906C312.827 210.906 313.14 210.592 313.14 210.206C313.14 209.819 312.827 209.506 312.44 209.506C312.053 209.506 311.74 209.819 311.74 210.206C311.74 210.592 312.053 210.906 312.44 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 206.266C336.957 206.266 337.27 205.952 337.27 205.566C337.27 205.179 336.957 204.866 336.57 204.866C336.183 204.866 335.87 205.179 335.87 205.566C335.87 205.952 336.183 206.266 336.57 206.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 210.906C344.997 210.906 345.31 210.592 345.31 210.206C345.31 209.819 344.997 209.506 344.61 209.506C344.223 209.506 343.91 209.819 343.91 210.206C343.91 210.592 344.223 210.906 344.61 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 215.556C353.037 215.556 353.35 215.242 353.35 214.856C353.35 214.469 353.037 214.156 352.65 214.156C352.263 214.156 351.95 214.469 351.95 214.856C351.95 215.242 352.263 215.556 352.65 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 220.196C361.077 220.196 361.39 219.882 361.39 219.496C361.39 219.109 361.077 218.796 360.69 218.796C360.303 218.796 359.99 219.109 359.99 219.496C359.99 219.882 360.303 220.196 360.69 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 243.406C336.957 243.406 337.27 243.092 337.27 242.706C337.27 242.319 336.957 242.006 336.57 242.006C336.183 242.006 335.87 242.319 335.87 242.706C335.87 243.092 336.183 243.406 336.57 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 248.056C328.907 248.056 329.22 247.742 329.22 247.356C329.22 246.969 328.907 246.656 328.52 246.656C328.133 246.656 327.82 246.969 327.82 247.356C327.82 247.742 328.133 248.056 328.52 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 238.766C344.997 238.766 345.31 238.452 345.31 238.066C345.31 237.679 344.997 237.366 344.61 237.366C344.223 237.366 343.91 237.679 343.91 238.066C343.91 238.452 344.223 238.766 344.61 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 252.696C320.867 252.696 321.18 252.382 321.18 251.996C321.18 251.609 320.867 251.296 320.48 251.296C320.093 251.296 319.78 251.609 319.78 251.996C319.78 252.382 320.093 252.696 320.48 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 257.336C312.827 257.336 313.14 257.022 313.14 256.636C313.14 256.249 312.827 255.936 312.44 255.936C312.053 255.936 311.74 256.249 311.74 256.636C311.74 257.022 312.053 257.336 312.44 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 234.126C353.037 234.126 353.35 233.812 353.35 233.426C353.35 233.039 353.037 232.726 352.65 232.726C352.263 232.726 351.95 233.039 351.95 233.426C351.95 233.812 352.263 234.126 352.65 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 229.476C361.077 229.476 361.39 229.162 361.39 228.776C361.39 228.389 361.077 228.076 360.69 228.076C360.303 228.076 359.99 228.389 359.99 228.776C359.99 229.162 360.303 229.476 360.69 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 224.836C369.117 224.836 369.43 224.522 369.43 224.136C369.43 223.749 369.117 223.436 368.73 223.436C368.343 223.436 368.03 223.749 368.03 224.136C368.03 224.522 368.343 224.836 368.73 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 248.056C344.997 248.056 345.31 247.742 345.31 247.356C345.31 246.969 344.997 246.656 344.61 246.656C344.223 246.656 343.91 246.969 343.91 247.356C343.91 247.742 344.223 248.056 344.61 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 252.696C336.957 252.696 337.27 252.382 337.27 251.996C337.27 251.609 336.957 251.296 336.57 251.296C336.183 251.296 335.87 251.609 335.87 251.996C335.87 252.382 336.183 252.696 336.57 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 243.406C353.037 243.406 353.35 243.092 353.35 242.706C353.35 242.319 353.037 242.006 352.65 242.006C352.263 242.006 351.95 242.319 351.95 242.706C351.95 243.092 352.263 243.406 352.65 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 257.336C328.907 257.336 329.22 257.022 329.22 256.636C329.22 256.249 328.907 255.936 328.52 255.936C328.133 255.936 327.82 256.249 327.82 256.636C327.82 257.022 328.133 257.336 328.52 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 261.976C320.867 261.976 321.18 261.662 321.18 261.276C321.18 260.889 320.867 260.576 320.48 260.576C320.093 260.576 319.78 260.889 319.78 261.276C319.78 261.662 320.093 261.976 320.48 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 238.766C361.077 238.766 361.39 238.452 361.39 238.066C361.39 237.679 361.077 237.366 360.69 237.366C360.303 237.366 359.99 237.679 359.99 238.066C359.99 238.452 360.303 238.766 360.69 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 234.126C369.117 234.126 369.43 233.812 369.43 233.426C369.43 233.039 369.117 232.726 368.73 232.726C368.343 232.726 368.03 233.039 368.03 233.426C368.03 233.812 368.343 234.126 368.73 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 229.476C377.157 229.476 377.47 229.162 377.47 228.776C377.47 228.389 377.157 228.076 376.77 228.076C376.383 228.076 376.07 228.389 376.07 228.776C376.07 229.162 376.383 229.476 376.77 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 252.696C353.037 252.696 353.35 252.382 353.35 251.996C353.35 251.609 353.037 251.296 352.65 251.296C352.263 251.296 351.95 251.609 351.95 251.996C351.95 252.382 352.263 252.696 352.65 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 257.336C344.997 257.336 345.31 257.022 345.31 256.636C345.31 256.249 344.997 255.936 344.61 255.936C344.223 255.936 343.91 256.249 343.91 256.636C343.91 257.022 344.223 257.336 344.61 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 248.056C361.077 248.056 361.39 247.742 361.39 247.356C361.39 246.969 361.077 246.656 360.69 246.656C360.303 246.656 359.99 246.969 359.99 247.356C359.99 247.742 360.303 248.056 360.69 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 261.976C336.957 261.976 337.27 261.662 337.27 261.276C337.27 260.889 336.957 260.576 336.57 260.576C336.183 260.576 335.87 260.889 335.87 261.276C335.87 261.662 336.183 261.976 336.57 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 266.626C328.907 266.626 329.22 266.312 329.22 265.926C329.22 265.539 328.907 265.226 328.52 265.226C328.133 265.226 327.82 265.539 327.82 265.926C327.82 266.312 328.133 266.626 328.52 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 243.406C369.117 243.406 369.43 243.092 369.43 242.706C369.43 242.319 369.117 242.006 368.73 242.006C368.343 242.006 368.03 242.319 368.03 242.706C368.03 243.092 368.343 243.406 368.73 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 238.766C377.157 238.766 377.47 238.452 377.47 238.066C377.47 237.679 377.157 237.366 376.77 237.366C376.383 237.366 376.07 237.679 376.07 238.066C376.07 238.452 376.383 238.766 376.77 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 234.126C385.197 234.126 385.51 233.812 385.51 233.426C385.51 233.039 385.197 232.726 384.81 232.726C384.423 232.726 384.11 233.039 384.11 233.426C384.11 233.812 384.423 234.126 384.81 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 257.336C361.077 257.336 361.39 257.022 361.39 256.636C361.39 256.249 361.077 255.936 360.69 255.936C360.303 255.936 359.99 256.249 359.99 256.636C359.99 257.022 360.303 257.336 360.69 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 261.976C353.037 261.976 353.35 261.662 353.35 261.276C353.35 260.889 353.037 260.576 352.65 260.576C352.263 260.576 351.95 260.889 351.95 261.276C351.95 261.662 352.263 261.976 352.65 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 252.696C369.117 252.696 369.43 252.382 369.43 251.996C369.43 251.609 369.117 251.296 368.73 251.296C368.343 251.296 368.03 251.609 368.03 251.996C368.03 252.382 368.343 252.696 368.73 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 266.626C344.997 266.626 345.31 266.312 345.31 265.926C345.31 265.539 344.997 265.226 344.61 265.226C344.223 265.226 343.91 265.539 343.91 265.926C343.91 266.312 344.223 266.626 344.61 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57 271.266C336.957 271.266 337.27 270.952 337.27 270.566C337.27 270.179 336.957 269.866 336.57 269.866C336.183 269.866 335.87 270.179 335.87 270.566C335.87 270.952 336.183 271.266 336.57 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 248.056C377.157 248.056 377.47 247.742 377.47 247.356C377.47 246.969 377.157 246.656 376.77 246.656C376.383 246.656 376.07 246.969 376.07 247.356C376.07 247.742 376.383 248.056 376.77 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 243.406C385.197 243.406 385.51 243.092 385.51 242.706C385.51 242.319 385.197 242.006 384.81 242.006C384.423 242.006 384.11 242.319 384.11 242.706C384.11 243.092 384.423 243.406 384.81 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86 238.766C393.247 238.766 393.56 238.452 393.56 238.066C393.56 237.679 393.247 237.366 392.86 237.366C392.473 237.366 392.16 237.679 392.16 238.066C392.16 238.452 392.473 238.766 392.86 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 261.976C369.117 261.976 369.43 261.662 369.43 261.276C369.43 260.889 369.117 260.576 368.73 260.576C368.343 260.576 368.03 260.889 368.03 261.276C368.03 261.662 368.343 261.976 368.73 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 266.626C361.077 266.626 361.39 266.312 361.39 265.926C361.39 265.539 361.077 265.226 360.69 265.226C360.303 265.226 359.99 265.539 359.99 265.926C359.99 266.312 360.303 266.626 360.69 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 257.336C377.157 257.336 377.47 257.022 377.47 256.636C377.47 256.249 377.157 255.936 376.77 255.936C376.383 255.936 376.07 256.249 376.07 256.636C376.07 257.022 376.383 257.336 376.77 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 271.266C353.037 271.266 353.35 270.952 353.35 270.566C353.35 270.179 353.037 269.866 352.65 269.866C352.263 269.866 351.95 270.179 351.95 270.566C351.95 270.952 352.263 271.266 352.65 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61 275.906C344.997 275.906 345.31 275.592 345.31 275.206C345.31 274.819 344.997 274.506 344.61 274.506C344.223 274.506 343.91 274.819 343.91 275.206C343.91 275.592 344.223 275.906 344.61 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 252.696C385.197 252.696 385.51 252.382 385.51 251.996C385.51 251.609 385.197 251.296 384.81 251.296C384.423 251.296 384.11 251.609 384.11 251.996C384.11 252.382 384.423 252.696 384.81 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86 248.056C393.247 248.056 393.56 247.742 393.56 247.356C393.56 246.969 393.247 246.656 392.86 246.656C392.473 246.656 392.16 246.969 392.16 247.356C392.16 247.742 392.473 248.056 392.86 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 243.406C401.287 243.406 401.6 243.092 401.6 242.706C401.6 242.319 401.287 242.006 400.9 242.006C400.513 242.006 400.2 242.319 400.2 242.706C400.2 243.092 400.513 243.406 400.9 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 266.626C377.157 266.626 377.47 266.312 377.47 265.926C377.47 265.539 377.157 265.226 376.77 265.226C376.383 265.226 376.07 265.539 376.07 265.926C376.07 266.312 376.383 266.626 376.77 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 271.266C369.117 271.266 369.43 270.952 369.43 270.566C369.43 270.179 369.117 269.866 368.73 269.866C368.343 269.866 368.03 270.179 368.03 270.566C368.03 270.952 368.343 271.266 368.73 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 261.976C385.197 261.976 385.51 261.662 385.51 261.276C385.51 260.889 385.197 260.576 384.81 260.576C384.423 260.576 384.11 260.889 384.11 261.276C384.11 261.662 384.423 261.976 384.81 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 275.906C361.077 275.906 361.39 275.592 361.39 275.206C361.39 274.819 361.077 274.506 360.69 274.506C360.303 274.506 359.99 274.819 359.99 275.206C359.99 275.592 360.303 275.906 360.69 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 280.546C353.037 280.546 353.35 280.232 353.35 279.846C353.35 279.459 353.037 279.146 352.65 279.146C352.263 279.146 351.95 279.459 351.95 279.846C351.95 280.232 352.263 280.546 352.65 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86 257.336C393.247 257.336 393.56 257.022 393.56 256.636C393.56 256.249 393.247 255.936 392.86 255.936C392.473 255.936 392.16 256.249 392.16 256.636C392.16 257.022 392.473 257.336 392.86 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 252.696C401.287 252.696 401.6 252.382 401.6 251.996C401.6 251.609 401.287 251.296 400.9 251.296C400.513 251.296 400.2 251.609 400.2 251.996C400.2 252.382 400.513 252.696 400.9 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.94 248.056C409.327 248.056 409.64 247.742 409.64 247.356C409.64 246.969 409.327 246.656 408.94 246.656C408.553 246.656 408.24 246.969 408.24 247.356C408.24 247.742 408.553 248.056 408.94 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 271.266C385.197 271.266 385.51 270.952 385.51 270.566C385.51 270.179 385.197 269.866 384.81 269.866C384.423 269.866 384.11 270.179 384.11 270.566C384.11 270.952 384.423 271.266 384.81 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 275.906C377.157 275.906 377.47 275.592 377.47 275.206C377.47 274.819 377.157 274.506 376.77 274.506C376.383 274.506 376.07 274.819 376.07 275.206C376.07 275.592 376.383 275.906 376.77 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86 266.626C393.247 266.626 393.56 266.312 393.56 265.926C393.56 265.539 393.247 265.226 392.86 265.226C392.473 265.226 392.16 265.539 392.16 265.926C392.16 266.312 392.473 266.626 392.86 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73 280.546C369.117 280.546 369.43 280.232 369.43 279.846C369.43 279.459 369.117 279.146 368.73 279.146C368.343 279.146 368.03 279.459 368.03 279.846C368.03 280.232 368.343 280.546 368.73 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69 285.196C361.077 285.196 361.39 284.882 361.39 284.496C361.39 284.109 361.077 283.796 360.69 283.796C360.303 283.796 359.99 284.109 359.99 284.496C359.99 284.882 360.303 285.196 360.69 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 261.976C401.287 261.976 401.6 261.662 401.6 261.276C401.6 260.889 401.287 260.576 400.9 260.576C400.513 260.576 400.2 260.889 400.2 261.276C400.2 261.662 400.513 261.976 400.9 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.94 257.336C409.327 257.336 409.64 257.022 409.64 256.636C409.64 256.249 409.327 255.936 408.94 255.936C408.553 255.936 408.24 256.249 408.24 256.636C408.24 257.022 408.553 257.336 408.94 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.98 252.696C417.367 252.696 417.68 252.382 417.68 251.996C417.68 251.609 417.367 251.296 416.98 251.296C416.593 251.296 416.28 251.609 416.28 251.996C416.28 252.382 416.593 252.696 416.98 252.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86 275.906C393.247 275.906 393.56 275.592 393.56 275.206C393.56 274.819 393.247 274.506 392.86 274.506C392.473 274.506 392.16 274.819 392.16 275.206C392.16 275.592 392.473 275.906 392.86 275.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81 280.546C385.197 280.546 385.51 280.232 385.51 279.846C385.51 279.459 385.197 279.146 384.81 279.146C384.423 279.146 384.11 279.459 384.11 279.846C384.11 280.232 384.423 280.546 384.81 280.546Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 271.266C401.287 271.266 401.6 270.952 401.6 270.566C401.6 270.179 401.287 269.866 400.9 269.866C400.513 269.866 400.2 270.179 400.2 270.566C400.2 270.952 400.513 271.266 400.9 271.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 285.196C377.157 285.196 377.47 284.882 377.47 284.496C377.47 284.109 377.157 283.796 376.77 283.796C376.383 283.796 376.07 284.109 376.07 284.496C376.07 284.882 376.383 285.196 376.77 285.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.94 266.626C409.327 266.626 409.64 266.312 409.64 265.926C409.64 265.539 409.327 265.226 408.94 265.226C408.553 265.226 408.24 265.539 408.24 265.926C408.24 266.312 408.553 266.626 408.94 266.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.98 261.976C417.367 261.976 417.68 261.662 417.68 261.276C417.68 260.889 417.367 260.576 416.98 260.576C416.593 260.576 416.28 260.889 416.28 261.276C416.28 261.662 416.593 261.976 416.98 261.976Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.02 257.336C425.407 257.336 425.72 257.022 425.72 256.636C425.72 256.249 425.407 255.936 425.02 255.936C424.633 255.936 424.32 256.249 424.32 256.636C424.32 257.022 424.633 257.336 425.02 257.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52 201.626C328.907 201.626 329.22 201.312 329.22 200.926C329.22 200.539 328.907 200.226 328.52 200.226C328.133 200.226 327.82 200.539 327.82 200.926C327.82 201.312 328.133 201.626 328.52 201.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 224.836C288.707 224.836 289.02 224.522 289.02 224.136C289.02 223.749 288.707 223.436 288.32 223.436C287.933 223.436 287.62 223.749 287.62 224.136C287.62 224.522 287.933 224.836 288.32 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 229.476C296.747 229.476 297.06 229.162 297.06 228.776C297.06 228.389 296.747 228.076 296.36 228.076C295.973 228.076 295.66 228.389 295.66 228.776C295.66 229.162 295.973 229.476 296.36 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 229.476C280.667 229.476 280.98 229.162 280.98 228.776C280.98 228.389 280.667 228.076 280.28 228.076C279.893 228.076 279.58 228.389 279.58 228.776C279.58 229.162 279.893 229.476 280.28 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 234.126C288.707 234.126 289.02 233.812 289.02 233.426C289.02 233.039 288.707 232.726 288.32 232.726C287.933 232.726 287.62 233.039 287.62 233.426C287.62 233.812 287.933 234.126 288.32 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 238.766C296.747 238.766 297.06 238.452 297.06 238.066C297.06 237.679 296.747 237.366 296.36 237.366C295.973 237.366 295.66 237.679 295.66 238.066C295.66 238.452 295.973 238.766 296.36 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 238.766C280.667 238.766 280.98 238.452 280.98 238.066C280.98 237.679 280.667 237.366 280.28 237.366C279.893 237.366 279.58 237.679 279.58 238.066C279.58 238.452 279.893 238.766 280.28 238.766Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 243.406C288.707 243.406 289.02 243.092 289.02 242.706C289.02 242.319 288.707 242.006 288.32 242.006C287.933 242.006 287.62 242.319 287.62 242.706C287.62 243.092 287.933 243.406 288.32 243.406Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 234.126C272.617 234.126 272.93 233.812 272.93 233.426C272.93 233.039 272.617 232.726 272.23 232.726C271.843 232.726 271.53 233.039 271.53 233.426C271.53 233.812 271.843 234.126 272.23 234.126Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 248.056C296.747 248.056 297.06 247.742 297.06 247.356C297.06 246.969 296.747 246.656 296.36 246.656C295.973 246.656 295.66 246.969 295.66 247.356C295.66 247.742 295.973 248.056 296.36 248.056Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 220.196C280.667 220.196 280.98 219.882 280.98 219.496C280.98 219.109 280.667 218.796 280.28 218.796C279.893 218.796 279.58 219.109 279.58 219.496C279.58 219.882 279.893 220.196 280.28 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 224.836C272.617 224.836 272.93 224.522 272.93 224.136C272.93 223.749 272.617 223.436 272.23 223.436C271.843 223.436 271.53 223.749 271.53 224.136C271.53 224.522 271.843 224.836 272.23 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 210.906C296.747 210.906 297.06 210.592 297.06 210.206C297.06 209.819 296.747 209.506 296.36 209.506C295.973 209.506 295.66 209.819 295.66 210.206C295.66 210.592 295.973 210.906 296.36 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 215.556C288.707 215.556 289.02 215.242 289.02 214.856C289.02 214.469 288.707 214.156 288.32 214.156C287.933 214.156 287.62 214.469 287.62 214.856C287.62 215.242 287.933 215.556 288.32 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 206.266C304.787 206.266 305.1 205.952 305.1 205.566C305.1 205.179 304.787 204.866 304.4 204.866C304.013 204.866 303.7 205.179 303.7 205.566C303.7 205.952 304.013 206.266 304.4 206.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 229.476C264.577 229.476 264.89 229.162 264.89 228.776C264.89 228.389 264.577 228.076 264.19 228.076C263.803 228.076 263.49 228.389 263.49 228.776C263.49 229.162 263.803 229.476 264.19 229.476Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 201.626C280.667 201.626 280.98 201.312 280.98 200.926C280.98 200.539 280.667 200.226 280.28 200.226C279.893 200.226 279.58 200.539 279.58 200.926C279.58 201.312 279.893 201.626 280.28 201.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 206.266C272.617 206.266 272.93 205.952 272.93 205.566C272.93 205.179 272.617 204.866 272.23 204.866C271.843 204.866 271.53 205.179 271.53 205.566C271.53 205.952 271.843 206.266 272.23 206.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 210.906C264.577 210.906 264.89 210.592 264.89 210.206C264.89 209.819 264.577 209.506 264.19 209.506C263.803 209.506 263.49 209.819 263.49 210.206C263.49 210.592 263.803 210.906 264.19 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 215.556C256.537 215.556 256.85 215.242 256.85 214.856C256.85 214.469 256.537 214.156 256.15 214.156C255.763 214.156 255.45 214.469 255.45 214.856C255.45 215.242 255.763 215.556 256.15 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 210.906C280.667 210.906 280.98 210.592 280.98 210.206C280.98 209.819 280.667 209.506 280.28 209.506C279.893 209.506 279.58 209.819 279.58 210.206C279.58 210.592 279.893 210.906 280.28 210.906Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 215.556C272.617 215.556 272.93 215.242 272.93 214.856C272.93 214.469 272.617 214.156 272.23 214.156C271.843 214.156 271.53 214.469 271.53 214.856C271.53 215.242 271.843 215.556 272.23 215.556Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 206.266C288.707 206.266 289.02 205.952 289.02 205.566C289.02 205.179 288.707 204.866 288.32 204.866C287.933 204.866 287.62 205.179 287.62 205.566C287.62 205.952 287.933 206.266 288.32 206.266Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19 220.196C264.577 220.196 264.89 219.882 264.89 219.496C264.89 219.109 264.577 218.796 264.19 218.796C263.803 218.796 263.49 219.109 263.49 219.496C263.49 219.882 263.803 220.196 264.19 220.196Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15 224.836C256.537 224.836 256.85 224.522 256.85 224.136C256.85 223.749 256.537 223.436 256.15 223.436C255.763 223.436 255.45 223.749 255.45 224.136C255.45 224.522 255.763 224.836 256.15 224.836Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 201.626C312.827 201.626 313.14 201.312 313.14 200.926C313.14 200.539 312.827 200.226 312.44 200.226C312.053 200.226 311.74 200.539 311.74 200.926C311.74 201.312 312.053 201.626 312.44 201.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 192.336C296.747 192.336 297.06 192.022 297.06 191.636C297.06 191.249 296.747 190.936 296.36 190.936C295.973 190.936 295.66 191.249 295.66 191.636C295.66 192.022 295.973 192.336 296.36 192.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32 196.986C288.707 196.986 289.02 196.672 289.02 196.286C289.02 195.899 288.707 195.586 288.32 195.586C287.933 195.586 287.62 195.899 287.62 196.286C287.62 196.672 287.933 196.986 288.32 196.986Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 201.626C296.747 201.626 297.06 201.312 297.06 200.926C297.06 200.539 296.747 200.226 296.36 200.226C295.973 200.226 295.66 200.539 295.66 200.926C295.66 201.312 295.973 201.626 296.36 201.626Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 196.986C304.787 196.986 305.1 196.672 305.1 196.286C305.1 195.899 304.787 195.586 304.4 195.586C304.013 195.586 303.7 195.899 303.7 196.286C303.7 196.672 304.013 196.986 304.4 196.986Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 196.986C320.867 196.986 321.18 196.672 321.18 196.286C321.18 195.899 320.867 195.586 320.48 195.586C320.093 195.586 319.78 195.899 319.78 196.286C319.78 196.672 320.093 196.986 320.48 196.986Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 187.696C304.787 187.696 305.1 187.382 305.1 186.996C305.1 186.609 304.787 186.296 304.4 186.296C304.013 186.296 303.7 186.609 303.7 186.996C303.7 187.382 304.013 187.696 304.4 187.696Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 192.336C312.827 192.336 313.14 192.022 313.14 191.636C313.14 191.249 312.827 190.936 312.44 190.936C312.053 190.936 311.74 191.249 311.74 191.636C311.74 192.022 312.053 192.336 312.44 192.336Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11 220.196C248.497 220.196 248.81 219.882 248.81 219.496C248.81 219.109 248.497 218.796 248.11 218.796C247.723 218.796 247.41 219.109 247.41 219.496C247.41 219.882 247.723 220.196 248.11 220.196Z",
    fill: "#040919"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.28 164.176L250.95 185.926L260.85 180.216L223.18 158.466L213.28 164.176Z",
    fill: "#6BBEBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.81 179.016L227.17 166.526",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.82 183.856L213.49 174.426",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.05 189.396L199.81 182.326",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205.03 201.136L186.13 190.216",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.59 204.556L172.45 198.116",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.58 147.986C250.24 147.986 246.72 150.026 246.72 152.546C246.72 155.066 250.24 157.106 254.58 157.106C258.92 157.106 262.44 155.066 262.44 152.546C262.44 150.026 258.92 147.986 254.58 147.986Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.31 270.226C40.42 270.226 38.0699 271.586 38.0699 273.266C38.0699 274.946 40.41 276.306 43.31 276.306C46.21 276.306 48.55 274.946 48.55 273.266C48.55 271.586 46.21 270.226 43.31 270.226Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.46 262.036C54.57 262.036 52.22 263.396 52.22 265.076C52.22 266.756 54.56 268.116 57.46 268.116C60.36 268.116 62.7 266.756 62.7 265.076C62.7 263.396 60.36 262.036 57.46 262.036Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6199 253.846C68.7299 253.846 66.3799 255.206 66.3799 256.886C66.3799 258.566 68.7199 259.926 71.6199 259.926C74.5199 259.926 76.8599 258.566 76.8599 256.886C76.8599 255.206 74.5199 253.846 71.6199 253.846Z",
    fill: "#6BBEBA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.67 324.306L233.47 316.686C221.79 309.946 215.24 286.206 203.56 279.466C191.88 272.726 181.19 303.956 170.97 295.156C152.93 279.616 155.59 297.696 137.45 287.806L133.14 285.456L246.67 348.296V324.306Z",
    fill: "#CFD2D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.33 279.466V324.306",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.34 296.506V307.706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.14 285.456L137.45 287.806C155.59 297.696 152.93 279.616 170.97 295.156C181.19 303.956 191.88 272.726 203.56 279.466C215.24 286.206 221.79 309.946 233.47 316.686L246.67 324.306",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.37 285.736L119.74 291.726C131.42 298.466 137.97 280.426 149.65 287.166C161.33 293.906 167.88 325.466 179.56 332.216C191.24 338.956 197.79 333.556 209.47 340.296L222.91 348.056V362.016L109.38 299.176V285.736H109.37Z",
    fill: "#083B4A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.55 286.596V320.866",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 339.736V354.036",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 174.356L13.24 137.486L1.46997 144.286L77.0999 187.956L152.74 144.286L140.97 137.486L77.0999 174.356Z",
    fill: "#CFD2D3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.53 159.486L114.3 166.276",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 87.0156L1.46997 130.686L77.0999 174.356L152.74 130.686L77.0999 87.0156Z",
    fill: "url(#paint2_linear_1_1711)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M91.71 95.4457L31.81 130.026L76.89 156.056L136.79 121.476L91.71 95.4457Z",
    fill: "#CFD2D3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 174.356L152.74 130.686",
    stroke: "#040919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46997 130.686L77.0999 174.356",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 126.746C77.4865 126.746 77.8 126.432 77.8 126.046C77.8 125.659 77.4865 125.346 77.0999 125.346C76.7133 125.346 76.4 125.659 76.4 126.046C76.4 126.432 76.7133 126.746 77.0999 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 131.386C85.5366 131.386 85.8499 131.072 85.8499 130.686C85.8499 130.299 85.5366 129.986 85.15 129.986C84.7634 129.986 84.45 130.299 84.45 130.686C84.45 131.072 84.7634 131.386 85.15 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 136.026C77.4865 136.026 77.8 135.712 77.8 135.326C77.8 134.939 77.4865 134.626 77.0999 134.626C76.7133 134.626 76.4 134.939 76.4 135.326C76.4 135.712 76.7133 136.026 77.0999 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 136.026C93.5766 136.026 93.89 135.712 93.89 135.326C93.89 134.939 93.5766 134.626 93.19 134.626C92.8034 134.626 92.4899 134.939 92.4899 135.326C92.4899 135.712 92.8034 136.026 93.19 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 140.666C85.5366 140.666 85.8499 140.352 85.8499 139.966C85.8499 139.579 85.5366 139.266 85.15 139.266C84.7634 139.266 84.45 139.579 84.45 139.966C84.45 140.352 84.7634 140.666 85.15 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 145.316C77.4865 145.316 77.8 145.002 77.8 144.616C77.8 144.229 77.4865 143.916 77.0999 143.916C76.7133 143.916 76.4 144.229 76.4 144.616C76.4 145.002 76.7133 145.316 77.0999 145.316Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 140.666C101.617 140.666 101.93 140.352 101.93 139.966C101.93 139.579 101.617 139.266 101.23 139.266C100.843 139.266 100.53 139.579 100.53 139.966C100.53 140.352 100.843 140.666 101.23 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 145.316C93.5766 145.316 93.89 145.002 93.89 144.616C93.89 144.229 93.5766 143.916 93.19 143.916C92.8034 143.916 92.4899 144.229 92.4899 144.616C92.4899 145.002 92.8034 145.316 93.19 145.316Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 149.956C85.5366 149.956 85.8499 149.642 85.8499 149.256C85.8499 148.869 85.5366 148.556 85.15 148.556C84.7634 148.556 84.45 148.869 84.45 149.256C84.45 149.642 84.7634 149.956 85.15 149.956Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 154.596C77.4865 154.596 77.8 154.282 77.8 153.896C77.8 153.509 77.4865 153.196 77.0999 153.196C76.7133 153.196 76.4 153.509 76.4 153.896C76.4 154.282 76.7133 154.596 77.0999 154.596Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 149.956C101.617 149.956 101.93 149.642 101.93 149.256C101.93 148.869 101.617 148.556 101.23 148.556C100.843 148.556 100.53 148.869 100.53 149.256C100.53 149.642 100.843 149.956 101.23 149.956Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 154.596C93.5766 154.596 93.89 154.282 93.89 153.896C93.89 153.509 93.5766 153.196 93.19 153.196C92.8034 153.196 92.4899 153.509 92.4899 153.896C92.4899 154.282 92.8034 154.596 93.19 154.596Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27 145.316C109.657 145.316 109.97 145.002 109.97 144.616C109.97 144.229 109.657 143.916 109.27 143.916C108.883 143.916 108.57 144.229 108.57 144.616C108.57 145.002 108.883 145.316 109.27 145.316Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 159.246C85.5366 159.246 85.8499 158.932 85.8499 158.546C85.8499 158.159 85.5366 157.846 85.15 157.846C84.7634 157.846 84.45 158.159 84.45 158.546C84.45 158.932 84.7634 159.246 85.15 159.246Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 163.886C77.4865 163.886 77.8 163.572 77.8 163.186C77.8 162.799 77.4865 162.486 77.0999 162.486C76.7133 162.486 76.4 162.799 76.4 163.186C76.4 163.572 76.7133 163.886 77.0999 163.886Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 131.386C69.4466 131.386 69.7599 131.072 69.7599 130.686C69.7599 130.299 69.4466 129.986 69.06 129.986C68.6734 129.986 68.3599 130.299 68.3599 130.686C68.3599 131.072 68.6734 131.386 69.06 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 117.456C93.5766 117.456 93.89 117.142 93.89 116.756C93.89 116.369 93.5766 116.056 93.19 116.056C92.8034 116.056 92.4899 116.369 92.4899 116.756C92.4899 117.142 92.8034 117.456 93.19 117.456Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 122.096C101.617 122.096 101.93 121.782 101.93 121.396C101.93 121.009 101.617 120.696 101.23 120.696C100.843 120.696 100.53 121.009 100.53 121.396C100.53 121.782 100.843 122.096 101.23 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 126.746C93.5766 126.746 93.89 126.432 93.89 126.046C93.89 125.659 93.5766 125.346 93.19 125.346C92.8034 125.346 92.4899 125.659 92.4899 126.046C92.4899 126.432 92.8034 126.746 93.19 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27 126.746C109.657 126.746 109.97 126.432 109.97 126.046C109.97 125.659 109.657 125.346 109.27 125.346C108.883 125.346 108.57 125.659 108.57 126.046C108.57 126.432 108.883 126.746 109.27 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 131.386C101.617 131.386 101.93 131.072 101.93 130.686C101.93 130.299 101.617 129.986 101.23 129.986C100.843 129.986 100.53 130.299 100.53 130.686C100.53 131.072 100.843 131.386 101.23 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31 131.386C117.697 131.386 118.01 131.072 118.01 130.686C118.01 130.299 117.697 129.986 117.31 129.986C116.923 129.986 116.61 130.299 116.61 130.686C116.61 131.072 116.923 131.386 117.31 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27 136.026C109.657 136.026 109.97 135.712 109.97 135.326C109.97 134.939 109.657 134.626 109.27 134.626C108.883 134.626 108.57 134.939 108.57 135.326C108.57 135.712 108.883 136.026 109.27 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31 140.666C117.697 140.666 118.01 140.352 118.01 139.966C118.01 139.579 117.697 139.266 117.31 139.266C116.923 139.266 116.61 139.579 116.61 139.966C116.61 140.352 116.923 140.666 117.31 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35 136.026C125.737 136.026 126.05 135.712 126.05 135.326C126.05 134.939 125.737 134.626 125.35 134.626C124.963 134.626 124.65 134.939 124.65 135.326C124.65 135.712 124.963 136.026 125.35 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 122.096C85.5366 122.096 85.8499 121.782 85.8499 121.396C85.8499 121.009 85.5366 120.696 85.15 120.696C84.7634 120.696 84.45 121.009 84.45 121.396C84.45 121.782 84.7634 122.096 85.15 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27 117.456C109.657 117.456 109.97 117.142 109.97 116.756C109.97 116.369 109.657 116.056 109.27 116.056C108.883 116.056 108.57 116.369 108.57 116.756C108.57 117.142 108.883 117.456 109.27 117.456Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31 122.096C117.697 122.096 118.01 121.782 118.01 121.396C118.01 121.009 117.697 120.696 117.31 120.696C116.923 120.696 116.61 121.009 116.61 121.396C116.61 121.782 116.923 122.096 117.31 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35 126.746C125.737 126.746 126.05 126.432 126.05 126.046C126.05 125.659 125.737 125.346 125.35 125.346C124.963 125.346 124.65 125.659 124.65 126.046C124.65 126.432 124.963 126.746 125.35 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39 131.386C133.777 131.386 134.09 131.072 134.09 130.686C134.09 130.299 133.777 129.986 133.39 129.986C133.003 129.986 132.69 130.299 132.69 130.686C132.69 131.072 133.003 131.386 133.39 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 112.816C101.617 112.816 101.93 112.502 101.93 112.116C101.93 111.729 101.617 111.416 101.23 111.416C100.843 111.416 100.53 111.729 100.53 112.116C100.53 112.502 100.843 112.816 101.23 112.816Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 136.026C61.4066 136.026 61.72 135.712 61.72 135.326C61.72 134.939 61.4066 134.626 61.02 134.626C60.6334 134.626 60.32 134.939 60.32 135.326C60.32 135.712 60.6334 136.026 61.02 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 140.666C69.4466 140.666 69.7599 140.352 69.7599 139.966C69.7599 139.579 69.4466 139.266 69.06 139.266C68.6734 139.266 68.3599 139.579 68.3599 139.966C68.3599 140.352 68.6734 140.666 69.06 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9799 140.666C53.3665 140.666 53.68 140.352 53.68 139.966C53.68 139.579 53.3665 139.266 52.9799 139.266C52.5933 139.266 52.28 139.579 52.28 139.966C52.28 140.352 52.5933 140.666 52.9799 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 145.316C61.4066 145.316 61.72 145.002 61.72 144.616C61.72 144.229 61.4066 143.916 61.02 143.916C60.6334 143.916 60.32 144.229 60.32 144.616C60.32 145.002 60.6334 145.316 61.02 145.316Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 149.956C69.4466 149.956 69.7599 149.642 69.7599 149.256C69.7599 148.869 69.4466 148.556 69.06 148.556C68.6734 148.556 68.3599 148.869 68.3599 149.256C68.3599 149.642 68.6734 149.956 69.06 149.956Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9799 149.956C53.3665 149.956 53.68 149.642 53.68 149.256C53.68 148.869 53.3665 148.556 52.9799 148.556C52.5933 148.556 52.28 148.869 52.28 149.256C52.28 149.642 52.5933 149.956 52.9799 149.956Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 154.596C61.4066 154.596 61.72 154.282 61.72 153.896C61.72 153.509 61.4066 153.196 61.02 153.196C60.6334 153.196 60.32 153.509 60.32 153.896C60.32 154.282 60.6334 154.596 61.02 154.596Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94 145.316C45.3266 145.316 45.64 145.002 45.64 144.616C45.64 144.229 45.3266 143.916 44.94 143.916C44.5534 143.916 44.24 144.229 44.24 144.616C44.24 145.002 44.5534 145.316 44.94 145.316Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 159.246C69.4466 159.246 69.7599 158.932 69.7599 158.546C69.7599 158.159 69.4466 157.846 69.06 157.846C68.6734 157.846 68.3599 158.159 68.3599 158.546C68.3599 158.932 68.6734 159.246 69.06 159.246Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9799 131.386C53.3665 131.386 53.68 131.072 53.68 130.686C53.68 130.299 53.3665 129.986 52.9799 129.986C52.5933 129.986 52.28 130.299 52.28 130.686C52.28 131.072 52.5933 131.386 52.9799 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94 136.026C45.3266 136.026 45.64 135.712 45.64 135.326C45.64 134.939 45.3266 134.626 44.94 134.626C44.5534 134.626 44.24 134.939 44.24 135.326C44.24 135.712 44.5534 136.026 44.94 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 122.096C69.4466 122.096 69.7599 121.782 69.7599 121.396C69.7599 121.009 69.4466 120.696 69.06 120.696C68.6734 120.696 68.3599 121.009 68.3599 121.396C68.3599 121.782 68.6734 122.096 69.06 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 126.746C61.4066 126.746 61.72 126.432 61.72 126.046C61.72 125.659 61.4066 125.346 61.02 125.346C60.6334 125.346 60.32 125.659 60.32 126.046C60.32 126.432 60.6334 126.746 61.02 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 117.456C77.4865 117.456 77.8 117.142 77.8 116.756C77.8 116.369 77.4865 116.056 77.0999 116.056C76.7133 116.056 76.4 116.369 76.4 116.756C76.4 117.142 76.7133 117.456 77.0999 117.456Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 140.666C37.2866 140.666 37.6 140.352 37.6 139.966C37.6 139.579 37.2866 139.266 36.9 139.266C36.5134 139.266 36.2 139.579 36.2 139.966C36.2 140.352 36.5134 140.666 36.9 140.666Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9799 112.816C53.3665 112.816 53.68 112.502 53.68 112.116C53.68 111.729 53.3665 111.416 52.9799 111.416C52.5933 111.416 52.28 111.729 52.28 112.116C52.28 112.502 52.5933 112.816 52.9799 112.816Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94 117.456C45.3266 117.456 45.64 117.142 45.64 116.756C45.64 116.369 45.3266 116.056 44.94 116.056C44.5534 116.056 44.24 116.369 44.24 116.756C44.24 117.142 44.5534 117.456 44.94 117.456Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 122.096C37.2866 122.096 37.6 121.782 37.6 121.396C37.6 121.009 37.2866 120.696 36.9 120.696C36.5134 120.696 36.2 121.009 36.2 121.396C36.2 121.782 36.5134 122.096 36.9 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.86 126.746C29.2466 126.746 29.56 126.432 29.56 126.046C29.56 125.659 29.2466 125.346 28.86 125.346C28.4734 125.346 28.16 125.659 28.16 126.046C28.16 126.432 28.4734 126.746 28.86 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9799 122.096C53.3665 122.096 53.68 121.782 53.68 121.396C53.68 121.009 53.3665 120.696 52.9799 120.696C52.5933 120.696 52.28 121.009 52.28 121.396C52.28 121.782 52.5933 122.096 52.9799 122.096Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94 126.746C45.3266 126.746 45.64 126.432 45.64 126.046C45.64 125.659 45.3266 125.346 44.94 125.346C44.5534 125.346 44.24 125.659 44.24 126.046C44.24 126.432 44.5534 126.746 44.94 126.746Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 117.456C61.4066 117.456 61.72 117.142 61.72 116.756C61.72 116.369 61.4066 116.056 61.02 116.056C60.6334 116.056 60.32 116.369 60.32 116.756C60.32 117.142 60.6334 117.456 61.02 117.456Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 131.386C37.2866 131.386 37.6 131.072 37.6 130.686C37.6 130.299 37.2866 129.986 36.9 129.986C36.5134 129.986 36.2 130.299 36.2 130.686C36.2 131.072 36.5134 131.386 36.9 131.386Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.86 136.026C29.2466 136.026 29.56 135.712 29.56 135.326C29.56 134.939 29.2466 134.626 28.86 134.626C28.4734 134.626 28.16 134.939 28.16 135.326C28.16 135.712 28.4734 136.026 28.86 136.026Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 112.816C85.5366 112.816 85.8499 112.502 85.8499 112.116C85.8499 111.729 85.5366 111.416 85.15 111.416C84.7634 111.416 84.45 111.729 84.45 112.116C84.45 112.502 84.7634 112.816 85.15 112.816Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 103.526C69.4466 103.526 69.7599 103.212 69.7599 102.826C69.7599 102.439 69.4466 102.126 69.06 102.126C68.6734 102.126 68.3599 102.439 68.3599 102.826C68.3599 103.212 68.6734 103.526 69.06 103.526Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 108.176C61.4066 108.176 61.72 107.862 61.72 107.476C61.72 107.089 61.4066 106.776 61.02 106.776C60.6334 106.776 60.32 107.089 60.32 107.476C60.32 107.862 60.6334 108.176 61.02 108.176Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 112.816C69.4466 112.816 69.7599 112.502 69.7599 112.116C69.7599 111.729 69.4466 111.416 69.06 111.416C68.6734 111.416 68.3599 111.729 68.3599 112.116C68.3599 112.502 68.6734 112.816 69.06 112.816Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 108.176C77.4865 108.176 77.8 107.862 77.8 107.476C77.8 107.089 77.4865 106.776 77.0999 106.776C76.7133 106.776 76.4 107.089 76.4 107.476C76.4 107.862 76.7133 108.176 77.0999 108.176Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 108.176C93.5766 108.176 93.89 107.862 93.89 107.476C93.89 107.089 93.5766 106.776 93.19 106.776C92.8034 106.776 92.4899 107.089 92.4899 107.476C92.4899 107.862 92.8034 108.176 93.19 108.176Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0999 98.8856C77.4865 98.8856 77.8 98.5723 77.8 98.1857C77.8 97.7991 77.4865 97.4856 77.0999 97.4856C76.7133 97.4856 76.4 97.7991 76.4 98.1857C76.4 98.5723 76.7133 98.8856 77.0999 98.8856Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15 103.526C85.5366 103.526 85.8499 103.212 85.8499 102.826C85.8499 102.439 85.5366 102.126 85.15 102.126C84.7634 102.126 84.45 102.439 84.45 102.826C84.45 103.212 84.7634 103.526 85.15 103.526Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.81 131.386C21.1966 131.386 21.5099 131.072 21.5099 130.686C21.5099 130.299 21.1966 129.986 20.81 129.986C20.4234 129.986 20.11 130.299 20.11 130.686C20.11 131.072 20.4234 131.386 20.81 131.386Z",
    fill: "#040919"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 166.276L146.87 185.086L76.9799 225.446L92.29 234.286",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0279 116.312L69.0179 5.83218C69.2779 4.97218 69.6579 4.22219 70.1379 3.59219L70.0779 1.25223H74.708C75.8079 1.25223 76.9678 1.56219 78.0978 2.21219L112.378 22.0022C116.138 24.1722 118.188 29.3422 116.948 33.5022L83.958 143.982C83.088 146.892 80.8279 148.552 78.2679 148.552H73.6379L73.5978 146.852L40.6079 127.802C36.8479 125.632 34.7979 120.462 36.0379 116.302L36.0279 116.312Z",
    fill: "url(#paint3_linear_1_1711)",
    stroke: "url(#paint4_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.82 22.0022C111.58 24.1722 113.63 29.3422 112.39 33.5022L79.3997 143.982C78.1597 148.142 74.0696 149.762 70.3096 147.592L36.0297 127.802C32.2697 125.632 30.2197 120.462 31.4597 116.302L64.4496 5.82217C65.6897 1.66217 69.7796 0.0421872 73.5396 2.21219L107.82 22.0022Z",
    fill: "url(#paint5_linear_1_1711)",
    stroke: "url(#paint6_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1379 126.862L44.2379 125.162L45.2779 121.672L48.1779 123.372L47.1379 126.862Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3478 134.812L51.5379 131.412L53.6279 124.432L59.4379 127.832L57.3478 134.812Z",
    fill: "url(#paint7_linear_1_1711)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1379 126.862L44.2379 125.162L45.2779 121.672L48.1779 123.372L47.1379 126.862Z",
    fill: "url(#paint8_linear_1_1711)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2379 122.292L36.3279 120.602L37.3779 117.112L40.2779 118.802L39.2379 122.292Z",
    fill: "url(#paint9_linear_1_1711)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7479 137.612L62.8478 135.912L63.8879 132.422L66.7879 134.122L65.7479 137.612Z",
    fill: "url(#paint10_linear_1_1711)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6479 142.172L70.7479 140.482L71.7879 136.992L74.6979 138.682L73.6479 142.172Z",
    fill: "url(#paint11_linear_1_1711)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.179 29.2551L107.454 31.6383",
    stroke: "url(#paint12_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.227 31.2868L106.502 33.6701",
    stroke: "url(#paint13_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4179 97.0922L80.4979 118.502L84.4079 105.412L47.3179 84.0022L43.4179 97.0922Z",
    stroke: "url(#paint14_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5079 110.182L76.588 131.592L80.4979 118.502L43.4179 97.0922L39.5079 110.182Z",
    stroke: "url(#paint15_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4678 71.3022L51.0978 73.3921",
    stroke: "url(#paint16_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3578 75.8622L58.9879 77.9522",
    stroke: "url(#paint17_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2479 80.4121L66.8779 82.5122",
    stroke: "url(#paint18_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1379 84.9722L74.7679 87.0622",
    stroke: "url(#paint19_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0279 89.5221L82.6579 91.6222",
    stroke: "url(#paint20_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9179 94.0822L90.5479 96.1721",
    stroke: "url(#paint21_linear_1_1711)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.82 22.0022C111.58 24.1722 113.63 29.3422 112.39 33.5022L79.3998 143.982C78.1598 148.142 74.0698 149.762 70.3098 147.592L36.0298 127.802C32.2698 125.632 30.2198 120.462 31.4598 116.302L64.4498 5.82217C65.6898 1.66217 69.7797 0.0421872 73.5397 2.21219L107.82 22.0022Z",
    fill: "url(#paint22_linear_1_1711)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M232 258.896L186.81 262.606L112.67 219.796C110.39 218.476 108.53 219.556 108.53 222.186V224.096",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M321.33 380.566L365.38 406.006",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M306.31 367.276L298.27 371.916L306.31 376.566L314.35 371.916L306.31 367.276Z",
    fill: "#6BBEBA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M290.23 376.566L282.19 381.206L290.23 385.846L298.27 381.206L290.23 376.566Z",
    fill: "#083B4A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M274.14 385.846L266.1 390.486L274.14 395.136L282.19 390.486L274.14 385.846Z",
    fill: "#083B4A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M305.25 389.856L349.3 415.296",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M289.16 399.146L333.22 424.576",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M321.33 380.566L355.94 400.556",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M305.25 389.856L315.21 395.606",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M289.16 399.146L305.7 408.686",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M355.67 225.386L340.94 233.886C349.62 238.976 354.98 245.976 354.98 253.696C354.98 269.266 333.21 281.886 306.36 281.886V293.936C344.69 293.936 375.76 275.916 375.76 253.696C375.76 242.656 368.09 232.656 355.67 225.386Z",
    fill: "#CFD2D3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M306.35 213.456V225.506C319.88 225.506 332.12 228.716 340.94 233.886L355.67 225.386C343.09 218.026 325.65 213.456 306.36 213.456H306.35Z",
    fill: "#CFD2D3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M281.82 229.366C289.02 226.916 297.4 225.506 306.35 225.506V213.456C293.57 213.456 281.61 215.466 271.33 218.956L281.82 229.356V229.366Z",
    fill: "#CFD2D3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.73 253.706C257.73 243.326 267.41 234.266 281.82 229.366L271.33 218.966C250.77 225.946 236.95 238.886 236.95 253.706C236.95 255.716 237.21 257.686 237.7 259.616L258.26 257.846C257.92 256.496 257.73 255.106 257.73 253.706Z",
    fill: "#CFD2D3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M306.35 293.946C330.1 293.946 351.05 287.026 363.56 276.476L346.43 269.656C337.66 277.046 322.99 281.896 306.35 281.896C281.93 281.896 261.71 271.456 258.26 257.846L237.7 259.616C242.63 279.036 271.49 293.946 306.35 293.946Z",
    fill: "#CFD2D3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M355.67 218.246L340.94 226.746C349.62 231.836 354.98 238.836 354.98 246.556C354.98 262.126 333.21 274.746 306.36 274.746V286.796C344.69 286.796 375.76 268.776 375.76 246.556C375.76 235.516 368.09 225.516 355.67 218.246Z",
    fill: "#6BBEBA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M281.82 211.846C289.02 209.396 297.4 207.986 306.35 207.986V187.656L271.33 181.106V201.436L281.82 211.836V211.846Z",
    fill: "#083B4A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M281.82 191.516C289.02 189.066 297.4 187.656 306.35 187.656V175.606C293.57 175.606 281.61 177.616 271.33 181.106L281.82 191.506V191.516Z",
    fill: "#083B4A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M271.34 181.116L281.83 191.516C289.03 189.066 297.41 187.656 306.36 187.656",
    fill: "#083B4A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M271.34 181.116L281.83 191.516C289.03 189.066 297.41 187.656 306.36 187.656",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M240.76 227.426L236.95 226.226V246.546C236.95 248.556 237.21 250.536 237.7 252.466L251.34 251.296V215.076C245.13 221.206 240.76 227.436 240.76 227.436V227.426Z",
    fill: "#083B4A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.73 246.556C257.73 236.176 267.41 227.116 281.82 222.216V201.886L266.97 204.246C261.44 206.126 255.89 210.566 251.34 215.066V251.286L258.26 250.686C257.92 249.336 257.73 247.946 257.73 246.546V246.556Z",
    fill: "#083B4A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M257.73 226.226C257.73 215.846 267.41 206.786 281.82 201.886L271.33 191.486C250.77 198.466 236.95 211.406 236.95 226.226C236.95 228.236 237.21 230.206 237.7 232.136L258.26 230.366C257.92 229.016 257.73 227.626 257.73 226.226Z",
    fill: "#083B4A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 232.146L258.26 230.376C257.92 229.026 257.73 227.636 257.73 226.236C257.73 215.856 267.41 206.796 281.82 201.896",
    fill: "#083B4A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 232.146L258.26 230.376C257.92 229.026 257.73 227.636 257.73 226.236C257.73 215.856 267.41 206.796 281.82 201.896",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M346.43 267.726C337.43 274.826 322.99 274.996 306.35 274.996C281.93 274.996 261.71 269.516 258.26 255.906L237.7 244.766V252.496C242.65 271.906 271.49 286.796 306.34 286.796C330.09 286.796 351.04 279.876 363.55 269.336V261.636L346.42 267.736L346.43 267.726Z",
    fill: "#083B4A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M306.35 279.096C330.1 279.096 351.05 272.176 363.56 261.626L346.43 254.806C337.66 262.196 322.99 267.046 306.35 267.046C281.93 267.046 261.71 256.606 258.26 242.996L237.7 244.766C242.63 264.186 271.49 279.096 306.35 279.096Z",
    fill: "#083B4A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 244.766C242.63 264.186 271.49 279.096 306.35 279.096C330.1 279.096 351.05 272.176 363.56 261.626",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29 144.866V156.916C324.82 156.916 337.06 160.126 345.88 165.296L360.61 156.796C348.03 149.436 330.59 144.866 311.3 144.866H311.29Z",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29 124.536V136.586C324.82 136.586 337.06 139.796 345.88 144.966L360.61 136.466C348.03 129.106 330.59 124.536 311.3 124.536H311.29Z",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M345.87 144.966V165.296L360.6 156.796V136.466L345.87 144.966Z",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29 136.586V156.916",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 312.476L303.3 319.096L308.16 316.296L296.7 309.676L291.84 312.476Z",
    fill: "#6BBEBA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M272.07 301.066L289.02 310.846L293.88 308.046L276.93 298.266L272.07 301.066Z",
    fill: "#083B4A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M321.95 357.916L443.92 287.486L506.34 323.526L384.37 393.946L321.95 357.916Z",
    fill: "#CFD2D3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M321.95 348.916L354.23 330.276L416.64 366.316L384.37 384.946L321.95 348.916Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M333.34 349.226L353.38 337.656L372.84 348.886L352.8 360.456L333.34 349.226Z",
    fill: "#083B4A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M337.95 339.676L354.23 330.276L416.64 366.316L400.37 375.716L337.95 339.676Z",
    fill: "#CFD2D3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M416.64 366.316L384.37 384.946L321.95 348.916",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M337.95 327.476L370.23 308.836L432.64 344.876L400.37 363.516L337.95 327.476Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M350.02 327.376L370.05 315.806L389.51 327.036L369.47 338.606L350.02 327.376Z",
    fill: "#083B4A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M411.65 284.926L443.92 266.286L506.34 302.326L474.07 320.966L411.65 284.926Z",
    fill: "#083B4A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M375.1 306.026L407.37 287.396L469.79 323.436L437.51 342.066L375.1 306.026Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M387.55 305.706L407.58 294.136L427.04 305.366L407.01 316.936L387.55 305.706Z",
    fill: "#083B4A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M423.89 273.736L443.92 262.166L463.38 273.406L443.35 284.976L423.89 273.736Z",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M431.93 308.196L451.39 319.426",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M427.57 310.716L440.66 318.266",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M394.4 329.866L413.86 341.096",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M390.04 332.386L403.12 339.936",
    stroke: "#CFD2D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M411.65 274.136L443.92 255.506L506.34 291.546L474.07 310.176L411.65 274.136Z",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M350.02 327.376L370.05 315.806",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M387.55 305.706L407.58 294.136",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 310.836L493.1 311.706C494.65 312.606 495.92 314.806 495.92 316.596V331.456L511.62 340.526C514.81 342.366 517.42 346.886 517.42 350.576V378.006L482.09 357.606",
    stroke: "#6BBEBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1711",
    x1: 22.96,
    y1: 383.776,
    x2: 561.61,
    y2: 383.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CFD2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1711",
    x1: 292.285,
    y1: 136.616,
    x2: 213.421,
    y2: 521.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1711",
    x1: 1.46997,
    y1: 130.686,
    x2: 152.74,
    y2: 130.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFD2D3",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#CFD2D3",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#CFD2D3",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2101,
    stopColor: "#D0D3F5",
    stopOpacity: 0.320089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0D3F5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D0D3F5",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D0D3F5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D0D3F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1711",
    x1: 76.4929,
    y1: 1.25223,
    x2: 127.367,
    y2: 116.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1711",
    x1: 76.4929,
    y1: 1.25223,
    x2: 73.7129,
    y2: 200.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1711",
    x1: 86.9474,
    y1: 148.556,
    x2: 54.6482,
    y2: -10.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880803,
    stopColor: "#083B4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_1711",
    x1: 71.9247,
    y1: 1.24872,
    x2: 69.1451,
    y2: 200.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_1711",
    x1: 55.4879,
    y1: 124.432,
    x2: 55.1858,
    y2: 142.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_1711",
    x1: 46.2079,
    y1: 121.672,
    x2: 46.0565,
    y2: 130.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_1711",
    x1: 38.3029,
    y1: 117.112,
    x2: 38.1524,
    y2: 125.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_1711",
    x1: 64.8179,
    y1: 132.422,
    x2: 64.6664,
    y2: 141.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_1711",
    x1: 72.7229,
    y1: 136.992,
    x2: 72.5724,
    y2: 145.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_1711",
    x1: 105.374,
    y1: 29.3743,
    x2: 105.258,
    y2: 31.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_1711",
    x1: 104.423,
    y1: 31.406,
    x2: 104.307,
    y2: 33.5508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_1711",
    x1: 63.9129,
    y1: 84.0022,
    x2: 63.9129,
    y2: 118.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#0E4351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_1711",
    x1: 60.0029,
    y1: 97.0922,
    x2: 60.0029,
    y2: 131.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#0E4351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_1711",
    x1: 49.2828,
    y1: 71.3022,
    x2: 49.2828,
    y2: 73.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_1711",
    x1: 57.1729,
    y1: 75.8622,
    x2: 57.1729,
    y2: 77.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_1711",
    x1: 65.0629,
    y1: 80.4121,
    x2: 65.0629,
    y2: 82.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_1711",
    x1: 72.9529,
    y1: 84.9722,
    x2: 72.9529,
    y2: 87.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_1711",
    x1: 80.8429,
    y1: 89.5221,
    x2: 80.8429,
    y2: 91.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_1711",
    x1: 88.7329,
    y1: 94.0822,
    x2: 88.7329,
    y2: 96.1721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BBEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_1711",
    x1: 52.6822,
    y1: 116.772,
    x2: 112.752,
    y2: 7.33903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6BBEBA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506394,
    stopColor: "#6BBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#6BBEBA",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageImage2);
export default __webpack_public_path__ + "static/media/homePage-image-2.5a48bf8e68cf73f2a96cf3f323a9c6a2.svg";
export { ForwardRef as ReactComponent };